<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import DataTable from 'datatables.net-vue3';
import "@vueform/multiselect/themes/default.css";

export default {
    page: {
        title: "Invoice Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Invoice Listing",
            items: [
                {
                text: "Invoice Listing",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            invoice_listing:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
            blockUi: false,
      
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getInvoiceListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'soa/customers/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    console.log(response);
                    this.loadingRoles=false;
                    this.invoice_listing = response.data;
                    console.log('xxxxxx='+this.invoice_listing);                    
                } 
                else {
                    this.messageBag = ['No record.'];                    
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        downloadExcel: function () {
            this.blockUi = true;
            const posting_ = {                
                customer_id: this.$route.params.id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/soaListingExport', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'SOA Listing.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            })
            .finally(() => {
                this.blockUi = false;
            });
        },
    },

    components: {
        DataTable,
    },

    mounted() {
        this.getInvoiceListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
   <div class="card-body mb-5">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="py-3 row g-3 justify-content-end">
                                    <div class="col-sm-auto">
                                        <div>
                                            <div v-if="blockUi" class="spinner-border text-success">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3 && blockUi == false">                                      
                                                <i class="ri-file-excel-2-line align-middle me-1"></i> 
                                                Export Excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, ordering: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th scope="col">Transaction Date</th>           
                                            <th scope="col">Transaction</th>           
                                            <th scope="col">Description</th>
                                            <th scope="col">Debit</th>
                                            <th scope="col">Credit</th>           
                                            <th scope="col">Balance</th>           
  
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in invoice_listing" :key="index" class="content">
                                            <td>{{ item.date }}</td>
                                            <td>{{item.transaction}}</td>                               
                                            <td>
                                                <!-- <router-link :to="'/customer/customer-details/'+item.id" class="fw-medium link-secondary"> -->
                                                {{item.description}}
                                                <!-- </router-link> -->
                                            </td>
                                            <td>{{item.is_debit == true ? item.amount : ''}}</td>
                                            <td>{{item.is_debit == false ? item.amount : ''}}</td>
                                            <td>{{item.balance}}</td>                                                       
                                        </tr>                                        
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</template>
